{
  "messages": {
    "networkError": "A network error occurred. If the issue persists, please contact us.",
    "appointmentUpdatedValidationFailed": "Appointment was updated, but it failed external validation.",
    "appointmentCreatedValidationFailed": "Appointment was created, but it failed external validation.",
    "validationErrorDetail": "<br /> Validation Error: {error}"
  },
  "titles": {
    "warehouseRuleFailed": "Warehouse Rule Failed",
    "validationServerError": "Validation Server Error",
    "appointmentUpdatedWithValidationError": "Appointment updated with validation error",
    "appointmentCreatedWithValidationError": "Appointment created with validation error"
  }
}
